import { useCallback } from "react";
import { CsvColumn, CsvSchema } from "../services/csvSettingsService";

/**
 * CSVカラム操作ロジックをカプセル化するフック
 */
export function useCsvColumns(
  value: CsvSchema,
  onChange: (value: CsvSchema) => void
) {
  // カラム追加
  const addColumn = useCallback(() => {
    const newColumn: CsvColumn = {
      order: value.columns.length + 1,
      headerName: "",
      jsonPath: "",
      required: false,
    };
    onChange({
      ...value,
      columns: [...value.columns, newColumn],
    });
  }, [value, onChange]);

  // カラム更新
  const updateColumn = useCallback(
    (index: number, updates: Partial<CsvColumn>) => {
      const newColumns = [...value.columns];
      newColumns[index] = { ...newColumns[index], ...updates };
      onChange({
        ...value,
        columns: newColumns,
      });
    },
    [value, onChange]
  );

  // カラム削除
  const removeColumn = useCallback(
    (index: number) => {
      const newColumns = value.columns.filter((_, i) => i !== index).map(col => ({ ...col }));
      // order再番
      newColumns.forEach((col, i) => {
        col.order = i + 1;
      });
      onChange({
        ...value,
        columns: newColumns,
      });
    },
    [value, onChange]
  );

  // カラム移動
  const moveColumn = useCallback(
    (index: number, direction: "up" | "down") => {
      const columns = value.columns.map(col => ({ ...col }));
      if (direction === "up" && index > 0) {
        [columns[index - 1], columns[index]] = [
          columns[index],
          columns[index - 1],
        ];
      } else if (direction === "down" && index < columns.length - 1) {
        [columns[index], columns[index + 1]] = [
          columns[index + 1],
          columns[index],
        ];
      }
      // order再番
      columns.forEach((col, i) => {
        col.order = i + 1;
      });
      onChange({
        ...value,
        columns,
      });
    },
    [value, onChange]
  );

  return {
    columns: value.columns,
    addColumn,
    updateColumn,
    removeColumn,
    moveColumn,
  };
}
